import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../../../Context/UserContext";
import toast from "react-hot-toast";
import { BaseURL } from "../../../../../Reusable/BaseURL";
import RGPViewPageForm from "./NRGPViewPageForm";
import NRGPViewPageForm from "./NRGPViewPageForm";

export default function NRGPView() {
  const { darkTheme, loginData } = useContext(UserContext);

  const [division, setDivision] = useState("");
  const [item, setItem] = useState("");
  const [brand, setBrand] = useState("");
  const [unit, setUnit] = useState("");
  const [qty, setQty] = useState("");
  const [date, setDate] = useState("");
  const [severity, setSeverity] = useState("");
  const [remark, setRemark] = useState("");

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");

  const [unsavedIndentItem, setUnsavedIndentItem] = useState([]);
  const [allGatePasses, setAllGatePasses] = useState([]);

  // async function getUnsavedItemList() {
  //   const res = await fetch(`${BaseURL}/purchase/indent/unsaveditemlists`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         setUnsavedIndentItem(createRes.data);
  //         setSpinner(false);
  //       }
  //     });
  // }
  async function getAllIndentCreated() {
    const res = await fetch(`${BaseURL}/purchase/nrgp/approvedlist`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          setAllGatePasses(createRes.data);
          setSpinner(false);
        }
      });
  }

  useEffect(() => {
    // getAllIndentCreated();
    // getUnsavedItemList();
  }, []);

  // ADD INDENT ITEM
  // async function addIndentItem(e) {
  //   e.preventDefault();
  //   const formData = new FormData();
  //   formData.append("item_id", item.value || "");
  //   formData.append("brand", brand.label || "");
  //   formData.append("unit", unit.label || "");
  //   formData.append("qty", qty || "");

  //   const res = await fetch(`${BaseURL}/purchase/indent/saveitem`, {
  //     method: "POST",
  //     body: formData,
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         // getUnsavedItemList();
  //         setDivision("");
  //         setItem("");
  //         setBrand("");
  //         setUnit("");
  //         setQty("");
  //         setAddMoreToggle(false);
  //         toast.success("Added on lists");
  //       }
  //       if (createRes?.error?.message.item_id) {
  //         toast.error(createRes.error.message.item_id);
  //       } else if (createRes?.error?.message.brand) {
  //         toast.error(createRes.error.message.brand);
  //       } else if (createRes?.error?.message.unit) {
  //         toast.error(createRes.error.message.unit);
  //       } else if (createRes?.error?.message.qty) {
  //         toast.error(createRes.error.message.qty);
  //       } else if (createRes?.error?.message) {
  //         toast.error(createRes.error.message);
  //       }
  //     });
  // }

  // create
  // const itemId = unsavedIndentItem.map((item, index) => item.id);
  // async function createDivision(e) {
  //   e.preventDefault();

  //   const formData = {
  //     date: date,
  //     severity: severity.value,
  //     remarks: remark,
  //     items: itemId,
  //   };

  //   const res = await fetch(`${BaseURL}/purchase/indent/save`, {
  //     method: "POST",
  //     body: JSON.stringify(formData),
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         // getUnsavedItemList();
  //         toast.success("Success");
  //         setDivision("");
  //         setItem("");
  //         setBrand("");
  //         setUnit("");
  //         setQty("");

  //         setDate("");
  //         setSeverity("");
  //         setRemark("");
  //       }
  //       // if (createRes?.error?.message.name) {
  //       //   toast.error(createRes.error.message.name);
  //       // } else if (createRes?.error?.message.code) {
  //       //   toast.error(createRes.error.message.code);
  //       // }
  //     });
  // }

  // // Listing record
  // function firstPageList(url = `${BaseURL}/states?page=1`) {
  //   setSpinner(true);
  //   fetch(url, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((li) => {
  //       if (li?.status) {
  //         const revData = li.data.data.reverse();
  //         setFirstPage(revData);
  //         setTotalNo(li.data.total);
  //         setFrom(li.data.from);
  //         setTo(li.data.to);
  //         setLinks(li.data.links);
  //         setSpinner(false);
  //       }
  //     });
  // }

  // function editBtn(id) {
  //   fetch(`${BaseURL}/purchase/indent/get/${id}`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((selectedRecord) => {
  //       if (selectedRecord.status) {
  //         setChangingSelect(true);
  //         setAddMoreToggle(true);
  //         setSubmitAction("update");

  //         setDivision(selectedRecord.data.division || "");
  //         setItem(selectedRecord.data.item_name || "");
  //         setBrand(selectedRecord.data.brand || "");
  //         setUnit(selectedRecord.data.unit || "");
  //         setQty(selectedRecord.data.qty || "");
  //       }
  //     });
  //   setChangingSelect(false);
  // }

  // UPDATE A RECORD
  // async function updateIndentItem(e, id) {
  //   e.preventDefault();
  //   const formData = {
  //     item_id: item.value,
  //     brand: brand.label,
  //     unit: unit.label,
  //     qty: qty,
  //   };
  //   const updRes = await fetch(`${BaseURL}/purchase/indent/updateitem/${id}`, {
  //     method: "PATCH",
  //     body: JSON.stringify(formData),
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //       "Content-Type": "application/json",
  //     },
  //     // body: JSON.stringify({name: divisionName}),
  //   })
  //     .then((res) => res.json())
  //     .then((upd) => {
  //       if (upd.status) {
          // getUnsavedItemList();
  //         setGetId(0);
  //         setDivision("");
  //         setItem("");
  //         setBrand("");
  //         setUnit("");
  //         setQty("");

  //         setSubmitAction("submit");
  //         setAddMoreToggle(false);
  //         toast.success("Updated");
  //       }
  //       if (upd?.error?.message.name) {
  //         toast.error(upd.error.message.name);
  //       } else if (upd?.error?.message.code) {
  //         toast.error(upd.error.message.code);
  //       }
  //     });
  // }

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col gap-8 md:gap-1 lg:gap-4"
          >
            <div
              className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
                darkTheme ? "border-b-slate-700" : "border-b-slate-200"
              }`}
            >
              NRGP View 
            </div>
            <div className="w-full px-2">
              <NRGPViewPageForm
                // editBtn={editBtn}
                firstPageList={getAllIndentCreated}
                links={links}
                firstPage={allGatePasses}
                setGetId={setGetId}
                spinner={spinner}
                setSpinner={setSpinner}
                totalNo={totalNo}
                from={from}
                to={to}
                addMoreToggle={addMoreToggle}
                setAddMoreToggle={setAddMoreToggle}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
